module.exports = __webpack_public_path__ + "img/banner_text_en.db46b40a.png";